<template>
  <div class="builder-user-journey">
    <v-row>
      <v-col>
        <Draggable
          v-model="editableSteps"
        >
          <v-row
            v-for="(step, index) in editableSteps"
            :key="index"
            :data-testid="`journey-step-${step.name}-${index}`"
          >
            <v-col>
              <v-card outlined>
                <v-card-title>
                  <v-icon left>{{ stepInfo[step.name].icon }}</v-icon>
                  {{ step.name }}
                  <v-spacer></v-spacer>
                  <v-btn icon @click="removeStep(index)" title="Remove step">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-btn icon class="handler">
                    <v-icon>mdi-arrow-all</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  {{ stepInfo[step.name].description }}
                </v-card-text>

              </v-card>
            </v-col>
          </v-row>
        </Draggable>
      </v-col>
      <v-col>
        <v-menu>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              color="green" dark
            >
              <v-icon>mdi-plus</v-icon>
              Add step
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="step in availableSteps"
              :key="step"
              @click="addStep(step)"
            >
              <v-list-item-title>{{ step }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import { TranslationHandler } from '../../mixins/translation-handler'
import { UserJourneyStep, UserJourneyStepName } from '../../types'
import Draggable from 'vuedraggable'
import { Getter } from 'vuex-class'

@Component({
  components: { Draggable }
})
export default class BuilderPageModules extends Mixins(TranslationHandler) {
  @Getter journeySteps!: UserJourneyStep[]

  availableSteps: UserJourneyStepName[] = [
    'Home',
    'Login',
    'Newsletter',
    'Playlist',
    'Result'
  ]

  stepInfo: Record<UserJourneyStepName, {
    icon: string
    description: string
  }> = {
    Home: {
      icon: 'mdi-home',
      description: 'The home page'
    },
    Login: {
      icon: 'mdi-spotify',
      description: 'Spotify login to save playlist. Can be shown before or after generating the playlist'
    },
    Newsletter: {
      icon: 'mdi-email',
      description: 'Newsletter signup page'
    },
    Playlist: {
      icon: 'mdi-playlist-music',
      description: 'Track selection to generate the playlist'
    },
    Result: {
      icon: 'mdi-check',
      description: "The result page where user's playlist is shown"
    }
  }

  draggableOptions = {
    handle: '.handler',
  }

  get editableSteps () {
    return this.journeySteps
  }

  set editableSteps (steps: UserJourneyStep[]) {
    this.$store.commit('SET_JOURNEY_STEPS', steps)
  }

  removeStep (index: number) {
    this.editableSteps = this.editableSteps.filter((_, i) => i !== index)
  }

  addStep (step: UserJourneyStepName) {
    const newIndex = this.editableSteps.length
    this.editableSteps = [...this.editableSteps, { name: step, position: newIndex }]
  }
}
</script>
